module.exports = __webpack_public_path__ + "img/ep-logo2.dc3ffff2.svg";